var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, RouterOutlet } from '@angular/router';
import { ConfirmModalComponent } from '../../common/components/confirm.modal/confirm.modal.component';
import { ConfirmModalActions, ConfirmModalData } from '../../common/components/confirm.modal/confirm.modal.provider';
import { getRouteUrl, routeConfigs } from '../../common/constants/route.config';
import { clone } from '../../common/extensions';
import { AuthService } from '../../common/services/auth.service';
import { ModalService } from '../../common/services/modal.service';
import { AccountApiService } from '../../services/account.api.service';
import { AdminSocketService } from '../../services/admin.socket.service';
import { EventTimeService } from '../../services/event.time.service';
import { SchedulerApiService } from '../../services/scheduler.api.service';
import { AddSpiderEvenetsModalComponent } from './add.spider.events.modal/add.spider.events.modal.component';
import { AddSpiderEventsModalActions, AddSpiderEventsModalData, } from './add.spider.events.modal/add.spider.events.modal.provider';
import { localStorageKeys } from '../../common/constants/local.storage.keys';
import * as jwt_decode from 'jwt-decode';
import { SerpConfig } from '../../models/admin/serp.config';
import { AlertifyService } from '../../services/alertify.service';
import { TravelBuddyConversationsModalComponent } from './accounts/travel.buddy.conversations/travel.buddy.conversations.modal.component';
import { TravelBuddyConversationsModalActions, TravelBuddyConversationsModalData, } from './accounts/travel.buddy.conversations/travel.buddy.conversations.modal.provider';
import { EventPullingStatusModalComponent } from './accounts/event.pulling.status/event.pulling.status.modal.component';
var AdminComponent = /** @class */ (function () {
    function AdminComponent(router, authService, accountApiService, formBuilder, modalService, schedulerApiService, adminSocketService, alertify) {
        this.router = router;
        this.authService = authService;
        this.accountApiService = accountApiService;
        this.formBuilder = formBuilder;
        this.modalService = modalService;
        this.schedulerApiService = schedulerApiService;
        this.adminSocketService = adminSocketService;
        this.alertify = alertify;
        this.schedulerProgressReports = [];
        this.isEventPuller = false;
        this.code = null;
        this.identifier = null;
        this.token = null;
        this.isShowUpdatePlaceBtn = false;
        this.isShowUpdateMultiDateEvents = false;
        this.isShowMissingAddress = false;
        this.isShowUpdateEventfulImage = false;
        this.isShowRemoveOutdatedEventsBtn = false;
        this.isShowRemoveDuplicatedPlaces = false;
        this.isShowCode = false;
        this.isShowEventbritePlaceId = false;
        this.isShowUpdateAllowedCover = false;
        this.isShowFromTo = false;
        this.from = null;
        this.to = null;
        this.isSpiderUseProxy = true;
        this.isUseCityCodeAPIOnEventbriteHomepage = true;
        this.isUseCityCode = true;
        this.isUseLinks = true;
        this.isAutoScrolling = true;
        this.spiderTip = 'e.g., https://www.facebook.com/pg/msmuseumart/events/';
        this.isShowUseLinkChk = false;
        this.fbPages = [];
        this.spiderLink = ''; //'https://www.facebook.com/pg/rockandrollhalloffame/events/, https://www.facebook.com/pg/msmuseumart/events/';
        this.serpGoogleConfig = new SerpConfig(false, 30, 50, false);
        this.adminSocketService.init();
    }
    AdminComponent.prototype.ngOnInit = function () {
        var _this = this;
        var authToken = localStorage.getItem(localStorageKeys.authToken);
        var tokenInfo = jwt_decode(authToken);
        if (tokenInfo && tokenInfo.role === 'ig-event-puller') {
            this.isEventPuller = true;
        }
        console.log('tokenInfo', tokenInfo);
        this.fetchAccounts();
        this.eventSource = 'all';
        this.adminSocketService.socket.on('scheduler-status', function (isRunning) { return (_this.isSchedulerRunning = isRunning); });
        this.adminSocketService.socket.on('scheduler-progress', function (report) {
            _this.schedulerProgressReports.push(report);
            if (_this.isAutoScrolling) {
                setTimeout(function () {
                    _this.reportsContainer.nativeElement.scrollTo({
                        top: _this.reportsContainer.nativeElement.scrollHeight,
                    });
                });
            }
        });
        this.codeFormGroup = this.formBuilder.group({
            evalCode: [null],
            code: [null],
            identifier: [null],
            token: [null],
            from: [null],
            to: [null],
            spider: [null],
            gatherNumber: [null],
            maxPages: [null],
        });
        var wholeSpinner = document.getElementById('skeleton-mask');
        if (wholeSpinner) {
            wholeSpinner.style.display = 'none';
        }
    };
    AdminComponent.prototype.synceData = function () {
        var _this = this;
        this.confirm(function () {
            _this.schedulerProgressReports = [];
            if (_this.accountName) {
                _this.schedulerApiService.synceOne(_this.accountName, _this.eventSource, _this.from, _this.to).subscribe();
            }
            else {
                _this.schedulerApiService.synceAll(_this.eventSource).subscribe();
            }
        });
    };
    AdminComponent.prototype.updatePlaces = function () {
        var _this = this;
        this.confirm(function () {
            _this.schedulerApiService.updatePlaces(_this.accountName, _this.from, _this.to).subscribe();
        });
    };
    AdminComponent.prototype.runEventbriteConjob = function () {
        var _this = this;
        this.confirm(function () {
            _this.schedulerApiService
                .runEventbriteConjob(_this.isUseCityCode, _this.isUseCityCodeAPIOnEventbriteHomepage)
                .subscribe();
        });
    };
    AdminComponent.prototype.tagPlaceImageAvailability = function () {
        var _this = this;
        this.confirm(function () {
            _this.schedulerApiService.tagPlaceImageAvailability(_this.accountName, _this.from, _this.to).subscribe();
        });
    };
    AdminComponent.prototype.travelBuddyConversations = function () {
        this.modalService.show({
            component: TravelBuddyConversationsModalComponent,
            providers: [
                { provide: TravelBuddyConversationsModalActions, useValue: null },
                {
                    provide: TravelBuddyConversationsModalData,
                    useValue: new TravelBuddyConversationsModalData(),
                },
            ],
            panelClass: 'width-modal-4',
        });
    };
    AdminComponent.prototype.eventPullingStatus = function () {
        this.modalService.show({
            component: EventPullingStatusModalComponent,
            panelClass: 'width-modal-2',
        });
        // this.schedulerApiService.eventPullingStatus().subscribe((data) => {
        //   this.modalService.show({
        //     component: ShowInfoModalComponent,
        //     providers: [
        //       {provide: ShowInfoModalActions, useValue: null},
        //       {
        //         provide: InfoModalData,
        //         useValue: new InfoModalData(
        //           'Eventbrite pulling status',
        //           null,
        //           data.map((x) => {
        //             return `${x.hubName} - ${new Date(x.eventbrite.lastRunTime).toLocaleString()}`;
        //           })
        //         ),
        //       },
        //     ],
        //     panelClass: 'width-modal-2',
        //   });
        // });
    };
    AdminComponent.prototype.updatePlaceByFBId = function () {
        var _this = this;
        if (this.identifier) {
            this.confirm(function () {
                _this.schedulerApiService.updatePlaceByFBId(_this.identifier, _this.accountName, _this.token).subscribe();
            });
        }
    };
    AdminComponent.prototype.deleteOutDatedEvents = function () {
        var _this = this;
        this.confirm(function () {
            _this.schedulerApiService.deleteOutDatedEvents().subscribe();
        });
    };
    AdminComponent.prototype.updateMultiDateEvents = function () {
        var _this = this;
        this.confirm(function () {
            _this.schedulerApiService.updateMultiDateEvents().subscribe();
        });
    };
    AdminComponent.prototype.getLatAndLngFromGoogleForMissingAddressEvents = function () {
        var _this = this;
        this.confirm(function () {
            _this.schedulerApiService.getLatAndLngFromGoogleForMissingAddressEvents(_this.accountName).subscribe();
        });
    };
    AdminComponent.prototype.updatEventImages = function () {
        var _this = this;
        this.confirm(function () {
            _this.schedulerApiService.updatEventImages(_this.accountName).subscribe();
        });
    };
    AdminComponent.prototype.removeDuplicatedPlaces = function () {
        var _this = this;
        this.confirm(function () {
            _this.schedulerApiService.removeDuplicatedPlaces().subscribe();
        });
    };
    AdminComponent.prototype.updatePlacesForNext = function () {
        var _this = this;
        this.confirm(function () {
            _this.schedulerApiService.updatePlacesForNext().subscribe();
        });
    };
    AdminComponent.prototype.loadSpiderPages = function () {
        var _this = this;
        if (!this.accountId || this.eventSource === 'all') {
            return;
        }
        this.loading = true;
        this.fbPages = [];
        this.spiderLink = '';
        this.accountApiService.getSpiderEventPages(this.accountId).subscribe(function (pages) {
            // const socialName = this.eventSource === 'eventbrite' ? 'eventbrite' : 'facebook';
            _this.fbPages = pages
                ? clone(pages)
                    .pages.filter(function (x) { return x.socialName.indexOf(_this.eventSource) >= 0; })
                    .map(function (x) {
                    return {
                        url: x.url,
                        tag: x.tag,
                        checked: false,
                        socialName: x.socialName,
                    };
                })
                : [];
            _this.isUseLinks = !_this.fbPages.length;
            _this.isShowUseLinkChk = !!_this.fbPages.length;
            _this.loading = false;
        });
    };
    AdminComponent.prototype.filterUnofficialPlaces = function () {
        this.schedulerApiService.filterUnofficialPlaces(this.accountName).subscribe();
    };
    AdminComponent.prototype.getFBPulledEvents = function ($event) {
        var _this = this;
        if (this.eventSource.indexOf('serp|google') >= 0) {
            this.schedulerApiService
                .getSpiderPulledEvents(this.eventSource)
                .finally($event.complete)
                .subscribe(function (events) {
                var checkedSerpCities = _this.fbPages.filter(function (x) { return x.checked; });
                _this.showSerpGoogleEvents(events, checkedSerpCities);
            });
            return;
        }
        var socialName = this.eventSource === 'eventbrite' ? 'eventbrite' : 'facebook';
        this.schedulerApiService
            .getSpiderPulledEvents(socialName)
            .finally($event.complete)
            .subscribe(function (events) {
            if (!events) {
                console.log("no events: " + events);
                return;
            }
            events.forEach(function (page) {
                page.events.forEach(function (x) { return EventTimeService.processEventTime(x); });
            });
            _this.modalService.show({
                component: AddSpiderEvenetsModalComponent,
                providers: [
                    { provide: AddSpiderEventsModalActions, useValue: null },
                    {
                        provide: AddSpiderEventsModalData,
                        useValue: new AddSpiderEventsModalData(_this.accountName, _this.accounts, events, socialName),
                    },
                ],
                panelClass: 'width-modal-90p',
            });
        });
    };
    AdminComponent.prototype.stopPullingEvents = function ($event) {
        this.schedulerApiService
            .stopPullingEvents()
            .finally($event.complete)
            .subscribe(function (events) { });
    };
    AdminComponent.prototype.spider = function ($event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var pages, result, events, page, socialName, pages_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.eventSource.indexOf('serp|google') >= 0) {
                            this.pullSerpGoogleEvents($event);
                            return [2 /*return*/];
                        }
                        if (!(this.eventSource === 'eventbrite')) return [3 /*break*/, 2];
                        pages = this.fbPages.filter(function (y) { return y.checked; });
                        if (pages.length > 1) {
                            this.alertify.warning("Only the first page will be executed for now");
                        }
                        return [4 /*yield*/, this.pullEventbriteEventsByAPI(pages[0])];
                    case 1:
                        result = _a.sent();
                        if (result && result.success) {
                            events = result.events;
                            if (!events || !events.length) {
                                this.alertify.warning("No events found, please check the city code");
                                return [2 /*return*/];
                            }
                            events.forEach(function (x) { return EventTimeService.processEventTime(x, false); });
                            page = [{ events: events, pageLink: pages[0]['url'] }];
                            this.modalService.show({
                                component: AddSpiderEvenetsModalComponent,
                                providers: [
                                    { provide: AddSpiderEventsModalActions, useValue: null },
                                    {
                                        provide: AddSpiderEventsModalData,
                                        useValue: new AddSpiderEventsModalData(this.accountName, this.accounts, page, this.eventSource),
                                    },
                                ],
                                panelClass: 'width-modal-90p',
                            });
                        }
                        else {
                            alert("No events pulled from this link");
                        }
                        return [2 /*return*/];
                    case 2:
                        socialName = this.eventSource !== 'eventbrite' ? 'facebook' : 'eventbrite';
                        if (!this.isUseLinks) {
                            this.spiderLink = '';
                            pages_1 = this.fbPages.filter(function (y) { return y.checked; });
                            pages_1.forEach(function (x, i) {
                                _this.spiderLink += x.url + (i === pages_1.length - 1 ? '' : ',');
                            });
                        }
                        console.log(this.spiderLink);
                        this.schedulerApiService
                            .spiderLink(this.spiderLink, socialName, this.isSpiderUseProxy, this.accountName)
                            .finally(function () {
                            $event.complete();
                        })
                            .subscribe(function (events) {
                            if (!events) {
                                console.log("no events: " + events);
                                return;
                            }
                            events.forEach(function (page) {
                                page.events.forEach(function (x) { return EventTimeService.processEventTime(x); });
                            });
                            _this.modalService.show({
                                component: AddSpiderEvenetsModalComponent,
                                providers: [
                                    { provide: AddSpiderEventsModalActions, useValue: null },
                                    {
                                        provide: AddSpiderEventsModalData,
                                        useValue: new AddSpiderEventsModalData(_this.accountName, _this.accounts, events, socialName),
                                    },
                                ],
                                panelClass: 'width-modal-90p',
                            });
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AdminComponent.prototype.addEventbritePlaceId = function ($event) {
        console.log("page: " + this.from + ", placeId: " + this.to);
        this.schedulerApiService.setSpiderPageConfig(this.from, this.to, 'eventbrite').finally($event.complete).subscribe();
    };
    AdminComponent.prototype.updatePlaceCover = function ($event) {
        this.schedulerApiService.updatePlaceCover().finally($event.complete).subscribe();
    };
    AdminComponent.prototype.logout = function () {
        this.authService.logout();
        this.router.navigateByUrl(getRouteUrl(routeConfigs.auth.login));
    };
    AdminComponent.prototype.setAccount = function (account) {
        this.accountName = account ? account.userName : null;
        this.accountId = account ? account._id : null;
        this.loadSpiderPages();
    };
    AdminComponent.prototype.setSource = function (source) {
        this.eventSource = source;
        if (source === 'eventbrite') {
            this.spiderTip = 'e.g., https://www.eventbrite.com/d/ga--brunswick/all-events/';
            this.spiderLink = '';
        }
        else if (source === 'facebook') {
            this.spiderTip = 'e.g., https://www.facebook.com/pg/msmuseumart/events/';
            this.spiderLink = '';
        }
        else if (source.indexOf('serp|google') >= 0) {
            this.spiderLink = 'serp google events'; //'https://serpapi.com/search.json?engine=google_events&q=Events+in+Savannah&hl=en&gl=us&&api_key=b25cfa1b3644220f01a3e6d0e611adc0d6825ef67eb53c91d181e72bb71b27f5';
        }
        this.loadSpiderPages();
    };
    AdminComponent.prototype.checkCode = function () {
        this.isShowUpdatePlaceBtn = this.code.indexOf('place') !== -1;
        this.isShowUpdateMultiDateEvents = this.code.indexOf('multi') !== -1;
        this.isShowRemoveOutdatedEventsBtn = this.code.indexOf('outdated') !== -1;
        this.isShowMissingAddress = this.code.indexOf('missing') !== -1;
        this.isShowUpdateEventfulImage = this.code.indexOf('eventful') !== -1;
        this.isShowRemoveDuplicatedPlaces = this.code.indexOf('duplicate') !== -1;
        this.isShowFromTo = this.code.indexOf('from') !== -1;
        this.isShowEventbritePlaceId = this.code.indexOf('eb') !== -1;
        this.isShowUpdateAllowedCover = this.code.indexOf('allow') !== -1;
    };
    AdminComponent.prototype.clearReport = function () {
        this.schedulerProgressReports = [];
    };
    AdminComponent.prototype.confirm = function (run) {
        var actions = {
            confirm: function (event) {
                event.complete();
                run();
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: 'Are you sure you want to do this?',
            confirmModalConfirmButtonText: 'Yes',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    AdminComponent.prototype.fetchAccounts = function () {
        var _this = this;
        this.accountApiService.getAccounts().subscribe(function (accounts) {
            accounts = accounts.filter(function (x) { return x.userName !== 'admin'; });
            _this.accounts = accounts;
        });
    };
    AdminComponent.prototype.pullEventbriteEventsByAPI = function (page) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // if (!page || !page.tag) {
                        //   alert(
                        //     "The selected link doesn't have a city code attached, please use dev server to run the crawler for this link."
                        //   );
                        //   return;
                        // }
                        this.isSchedulerRunning = true;
                        return [4 /*yield*/, this.schedulerApiService
                                .eventbriteApi(this.accountName, page)
                                .finally(function () { return (_this.isSchedulerRunning = false); })
                                .toPromise()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AdminComponent.prototype.pullSerpGoogleEvents = function ($event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var checkedSerpCities, eventsPulled, _i, checkedSerpCities_1, serpGoogle, city, result, status, maxTrying_1, retry_1, checkInterval_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isSchedulerRunning = true;
                        if (!!this.accountName) return [3 /*break*/, 2];
                        console.log('Pull Serp Google for all accounts');
                        return [4 /*yield*/, this.schedulerApiService.serpApi(null, null, this.serpGoogleConfig).toPromise()];
                    case 1:
                        _a.sent();
                        $event.complete();
                        return [2 /*return*/];
                    case 2:
                        checkedSerpCities = this.fbPages.filter(function (x) { return x.checked; });
                        console.log(checkedSerpCities);
                        if (!checkedSerpCities || !checkedSerpCities.length) {
                            this.isSchedulerRunning = false;
                            alert('No city selected, if there is no city, please set city name for this account in spider pages settings');
                            return [2 /*return*/];
                        }
                        eventsPulled = [];
                        _i = 0, checkedSerpCities_1 = checkedSerpCities;
                        _a.label = 3;
                    case 3:
                        if (!(_i < checkedSerpCities_1.length)) return [3 /*break*/, 6];
                        serpGoogle = checkedSerpCities_1[_i];
                        if (!(serpGoogle && serpGoogle.url)) return [3 /*break*/, 5];
                        city = serpGoogle.url;
                        if (serpGoogle.socialName.includes('serp|google|keywords')) {
                            this.serpGoogleConfig.type = 'keywords';
                            this.serpGoogleConfig.keywords = serpGoogle.url;
                            city = serpGoogle.tag;
                        }
                        else {
                            this.serpGoogleConfig.type = 'city';
                            this.serpGoogleConfig.keywords = undefined;
                        }
                        return [4 /*yield*/, this.schedulerApiService
                                .serpApi(this.accountName, city, this.serpGoogleConfig)
                                .finally($event.complete)
                                .toPromise()];
                    case 4:
                        result = _a.sent();
                        console.log(result);
                        result.success && eventsPulled.push.apply(eventsPulled, result.events);
                        !result.success && console.log("Error when pulling " + serpGoogle.url, result.msg);
                        _a.label = 5;
                    case 5:
                        _i++;
                        return [3 /*break*/, 3];
                    case 6: return [4 /*yield*/, this.schedulerApiService.checkSerpStatus().toPromise()];
                    case 7:
                        status = _a.sent();
                        console.log(status);
                        if (!status.isPulling) {
                            this.isSchedulerRunning = false;
                            this.showSerpGoogleEvents(eventsPulled, checkedSerpCities);
                        }
                        else {
                            maxTrying_1 = 30, retry_1 = 0;
                            checkInterval_1 = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                                var _this = this;
                                var status;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.schedulerApiService.checkSerpStatus().toPromise()];
                                        case 1:
                                            status = _a.sent();
                                            if (!status.isPulling) {
                                                clearInterval(checkInterval_1);
                                                this.isSchedulerRunning = false;
                                                this.schedulerApiService
                                                    .getSpiderPulledEvents('serp|google')
                                                    .finally($event.complete)
                                                    .subscribe(function (events) {
                                                    _this.showSerpGoogleEvents(events, checkedSerpCities);
                                                });
                                            }
                                            else {
                                                retry_1++;
                                                if (retry_1 >= maxTrying_1) {
                                                    clearInterval(checkInterval_1);
                                                    this.isSchedulerRunning = false;
                                                    alert('Seems the pulling is still in progress, please try to use the "SAVING EVENTS POPUP" to get pulled events, or retry the pulling');
                                                }
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, 10 * 1000);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AdminComponent.prototype.showSerpGoogleEvents = function (eventsPulled, checkedSerpCities) {
        if (!eventsPulled.length) {
            alert("No events found");
            return;
        }
        eventsPulled.forEach(function (x) { return EventTimeService.processEventTime(x, false); });
        var page = [{ events: eventsPulled, pageLink: checkedSerpCities.map(function (x) { return x.url; }).join('; ') }];
        this.modalService.show({
            component: AddSpiderEvenetsModalComponent,
            providers: [
                { provide: AddSpiderEventsModalActions, useValue: null },
                {
                    provide: AddSpiderEventsModalData,
                    useValue: new AddSpiderEventsModalData(this.accountName, this.accounts, page, this.eventSource),
                },
            ],
            panelClass: 'width-modal-90p',
        });
    };
    return AdminComponent;
}());
export { AdminComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/admin.component.ts.pre-build-optimizer.js